import { request, requestBlob } from './http';
const base='comercial-app/finanzas';
export const financePath=(kind,tail='')=>`${base}/${kind}${tail?`/${tail}`:''}`;
export const financeConfig=kind=>request(financePath(kind,'config'));
export const financeQuery=params=>new URLSearchParams(Object.fromEntries(Object.entries(params).filter(([,v])=>v!==''&&v!==undefined&&v!==null).map(([k,v])=>[k,Array.isArray(v)?JSON.stringify(v):v]))).toString();
export const financeLookup=(kind,resource,params={})=>request(`${financePath(kind,`catalogos/${resource}`)}?${financeQuery(params)}`);
export async function exportBanks(filters) {
 const blob=await requestBlob(financePath('bancos','exportar'),{method:'POST',body:filters});
 const url=URL.createObjectURL(blob);const a=document.createElement('a');a.href=url;a.download='ReporteBancos.xls';a.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
}
